<!-- =========================================================================================
  File Name: KardexReport.vue
  Description: kardex report
  ----------------------------------------------------------------------------------------
  Item Name: C4 - User list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>
  <div>
    <!--    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" :id="editID" @closeSidebar="addNewDataSidebar = false"/>-->
    <div class="vx-col w-full mb-base">
      <vx-card ref="parametersCard" class="mb-2">
        <div class="flex justify-between inline-block align-middle">
          <div class="mr-2" style="min-width: 495px;">
            <ejs-daterangepicker ref="period" :startDate="startDate" :endDate="endDate" floatLabelType="Auto" placeholder="Seleccione período"/>
          </div>
          <div class="w-full">
            <ejs-dropdownlist
              floatLabelType="Auto"
              placeholder="Seleccione producto"
              ref="product"
              highlight=true
              v-model="productId"
              :dataSource="products"
              :fields="{text: 'searchName', value: 'id'}"
              :query='productQuery'
              allowFiltering=true
              :filtering='productFiltering'
            />
          </div>
          <div>
            <vs-button radius color="success" type="filled" icon-pack="feather" icon="icon-search" class="ml-4 mt-2" @click="getReport"/>
          </div>
        </div>
      </vx-card>
      <vx-card v-show="gridReady">
        <ejs-grid
          ref="grid"
          :dataSource="data"
          locale='es-GT'
          :toolbar='toolbarOptions'
          :allowPaging="true"
          :pageSettings='pageSettings'
          :allowSorting='true'
          :sortSettings='sortOptions'
          :allowExcelExport='true'
          :toolbarClick='toolbarClick'
        >
          <e-columns>
            <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true"/>
            <e-column field='date' headerText='Fecha' width="150" :valueAccessor="formatDate"/>
            <e-column field="documentType" headerText="Tipo" width="100"/>
            <e-column field="document" headerText="Documento" width="200" :template="cTemplate" displayValue="document" routeName="stock_transaction" urlBase="/stock/transaction"/>
            <e-column field="in" type="number" headerText="Entradas" textAlign='Right' width="100" :valueAccessor="stockFormatter"/>
            <e-column field="out" type="number" headerText="Salidas" textAlign='Right' width="100" :valueAccessor="stockFormatter"/>
            <e-column field="value" type="number" headerText="Valor" textAlign='Right' format="N2" width="100"/>
            <e-column field="stock" type="number" headerText="Saldo" textAlign='Right' format="N2" width="100"/>
            <e-column field="cost" type="number" headerText="Costo unitario" textAlign='Right' format="N8" width="130"/>
            <e-column field="stockValue" type="number" headerText="Saldo" textAlign='Right' format="N2" width="100"/>
          </e-columns>
          <e-aggregates>
            <e-aggregate>
              <e-columns>
                <e-column type="Sum" field="in" format="N2"/>
                <e-column type="Sum" field="out" format="N2"/>
              </e-columns>
            </e-aggregate>
          </e-aggregates>
        </ejs-grid>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  var deltaPOS_config = require('@/deltaPOS.config')

  import * as lang from 'vuejs-datepicker/src/locale';
  // import AddNewDataSidebar from './OrderData';

  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {Query} from "@syncfusion/ej2-data";
  import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport, Aggregate} from '@syncfusion/ej2-vue-grids';
  import {DateRangePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
  import CellRendererLink from '@/views/infra/cell-renderer/CRLinkS';

  Vue.use(DateRangePickerPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(GridPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'daterangepicker': {
        placeholder: 'Seleccione período',
        startLabel: 'Fecha inicial',
        endLabel: 'Fecha final',
        applyText: 'Seleccionar',
        cancelText: 'Cancelar',
        selectedDays: 'Seleccione día inicial y final',
        days: 'Días'
      },
      'grid': {
        'EmptyRecord': 'No se encontraron transacciones para el producto seleccionado',
        'Search': 'Buscar',
        'Excelexport': 'Exportar'
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        loaded: false,
        gridReady: false,
        language: lang,
        startDate: null,
        endDate: null,
        products: [],
        productId: null,
        productQuery: new Query().select(['searchName', 'id']).take(20),
        data: [],
        editID: null,
        addNewDataSidebar: false,
        pageSettings: {pageSize: 10},
        toolbarOptions: ['Search', 'ExcelExport'],
        sortOptions: {columns: [{field: 'date', direction: 'Ascending'}, {field: 'document', direction: 'Ascending'}]},
        cardTitle: 'Kardex',
        cTemplate: function () {
          return {template: CellRendererLink, urlBase: '/stock/transaction/'};
        }
      }
    },
    components: {
      // AddNewDataSidebar,
      CellRendererLink
    },
    provide: {
      grid: [Toolbar, Search, Page, Sort, ExcelExport, Aggregate]
    },
    methods: {
      productFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.products));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          // var query = new Query().select(['name', 'id']);
          var query = new Query().select(['searchName', 'id']);
          query = (e.text !== '') ? query.where('searchName', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      numericFormat(value, decimals) {
        var ret = value;
        if (typeof value !== 'undefined') {
          ret = value.toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
        return ret;
      },
      stockFormatter(field, data) {
        return (data[field] == 0 ? '' : data[field].toFixed(2));
      },
      dateFormat(value) {
        var d = new Date(value);
        return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
      },
      dateISOFormat(value) {
        const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
        return d.toISOString();
      },
      formatDate: function (field, data) {
        var d = new Date(data[field].replace('Z', ''));
        return d.toLocaleString();
        // return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
      },
      toolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
          let excelExportProperties = {
            fileName: "Kardex.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
        }
      },
      getReport() {
        this.startDate = this.$refs.period.getSelectedRange().startDate;
        this.endDate = this.$refs.period.getSelectedRange().endDate;
        if (this.startDate) {
          if (this.endDate) {
            this.startDate.setHours(0);
            this.startDate.setMinutes(0);
            this.startDate.setSeconds(0);
            this.endDate.setHours(23);
            this.endDate.setMinutes(59);
            this.endDate.setSeconds(59);
            if (this.startDate < this.endDate) {
              this.$vs.loading({
                text: 'Cargando consulta',
                type: 'point'
              });
              var self = this;
              var data = {
                startDate: this.dateISOFormat(this.startDate),
                endDate: this.dateISOFormat(this.endDate),
                productId: this.productId,
                userId: this.$store.state.AppActiveUser.userId,
                token: this.$store.state.AppActiveUser.token
              };
              this.$http.post(deltaPOS_config.default.apiURL + '/reports/stock/kardex', data).then(response => {
                if (response.data.success) {
                  if (response.data.data) {
                    self.data = response.data.data
                  } else {
                    self.data = [];
                  }
                  self.gridReady = true;
                  self.$vs.loading.close();
                } else {
                  self.$vs.loading.close();
                  self.$vs.notify({
                    title: 'Error al cargar kardex',
                    text: response.data.message,
                    color: 'danger'
                  });
                }
                self.loaded = true;
              }).catch(error => {
                self.loaded = true;
                this.$vs.loading.close();
                var errorMessage = '';
                if (error.response) {
                  errorMessage = error.response.data.ErrorMessage
                } else {
                  errorMessage = 'Error de conectividad'
                }
                self.$vs.notify({
                  title: 'Error al cargar kardex',
                  text: errorMessage,
                  color: 'danger'
                });
              });
            } else {
              this.$vs.notify({
                title: 'Error en parámetros',
                text: 'Fecha final debe ser mayor a fecha inicial',
                color: 'danger'
              });
            }
          } else {
            this.$vs.notify({
              title: 'Error en parámetros',
              text: 'Debe especificar una fecha de finalización',
              color: 'danger'
            });
          }
        } else {
          this.$vs.notify({
            title: 'Error en parámetros',
            text: 'Debe especificar una fecha de inicio',
            color: 'danger'
          });
        }
      },
      refreshData() {
        this.getReport();
      }
    },
    mounted() {
      this.$vs.loading({
        text: 'Preparando consulta',
        type: 'point'
      });
      this.startDate = new Date();
      this.startDate.setHours(0);
      this.startDate.setMinutes(0);
      this.startDate.setSeconds(0);
      this.startDate.setDate(1)
      this.endDate = new Date();
      this.endDate.setHours(23);
      this.endDate.setMinutes(59);
      this.endDate.setSeconds(59);
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/products/list', this.$store.state.AppActiveUser)
        .then(response => {
          if (response.data.success) {
            self.products = response.data.data;
            self.$vs.loading.close();
          } else {
            self.$vs.loading.close();
            this.$vs.notify({
              title: 'Error al cargar productos',
              text: response.data.message,
              color: 'danger'
            });
          }
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
